import { render } from "./GoalCard.vue?vue&type=template&id=b1e1cf48&scoped=true"
import script from "./GoalCard.vue?vue&type=script&lang=js"
export * from "./GoalCard.vue?vue&type=script&lang=js"

import "./GoalCard.vue?vue&type=style&index=0&id=b1e1cf48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1e1cf48"

export default script